<template>
  <Row>
    <card-header name="数据概况" label="平台访问数据总览" color="#2d8cf0"></card-header>
    <Col span="24">
      <Row :gutter="25">
        <!-- <Col :sm="12" :md="12" :lg="6" :xl="4" v-if="isSystem">
          <box-sum title="店铺数" :value="simple_info.shop_count_sum" label="今日" :label_v="simple_info.shop_count_day" ></box-sum>
        </Col> -->
        <!-- <Col :sm="12" :md="12" :lg="6" :xl="4" v-if="isSystem">
          <box-sum title="菜品数" :value="simple_info.dish_count_sum" label="今日" :label_v="simple_info.dish_count_day" ></box-sum>
        </Col> -->
        <!-- <Col :sm="12" :md="12" :lg="6" :xl="4" v-if="simple_info.shop_book_count_sum">
          <box-sum title="店铺预约数" :value="simple_info.shop_book_count_sum" label="今日" :label_v="simple_info.shop_book_count_day" ></box-sum>
        </Col> -->
        <Col :sm="12" :md="12" :lg="6" :xl="4">
          <box-sum title="今日新增人数" :value="simple_info.user_count_day" label="-" :label_v="''"  ></box-sum>
        </Col>
        <Col :sm="12" :md="12" :lg="6" :xl="4">
          <box-sum title="总用户人数" :value="simple_info.user_count_sum" label="今日" :label_v="simple_info.user_count_day"  ></box-sum>
        </Col>
        <!-- <Col :sm="12" :md="12" :lg="6" :xl="4" @click.native="toUrl(demand)" >
          <box-sum title="建言献策待审核" :value="simple_infos.demand_num"></box-sum>
        </Col>
         <Col :sm="12" :md="12" :lg="6" :xl="4" @click.native="toUrl(publish)">
          <box-sum title="需求发布待审核" :value="simple_infos.publish_num"></box-sum>
        </Col>
        <Col :sm="12" :md="12" :lg="6" :xl="4" @click.native="toUrl(people)">
          <box-sum title="评论管理待审核" :value="simple_infos.people_num"></box-sum>
        </Col>
        <Col :sm="12" :md="12" :lg="6" :xl="4" @click.native="toUrl(recycle)">
          <box-sum title="上门回收待确认" :value="simple_infos.recycle_notverify"></box-sum>
        </Col>
        <Col :sm="12" :md="12" :lg="6" :xl="4" @click.native="toUrl(good)">
          <box-sum title="积分订单待核销" :value="simple_infos.good_notverify"></box-sum>
        </Col> -->
      </Row>
    </Col>
  </Row>
</template>
<script>
import BoxSum from './data/boxSum.vue'

export default {
  name: 'simple',
  components: {
    BoxSum,
  },
  data() {
    return {
      simple_info: {},
      simple_infos: {},
      demand:"demand_list",
      publish:"publish_list",
      people:"people_comment_list",
      recycle:"recycle_list",
      good:"pointorder_list",
    }
  },
  computed: {
    isAdmin() {
      return $utils.data.get('auth', 'is_admin') || false
    },
    isSystem() {
      return $utils.data.get('auth', 'is_system') || false
    },
    isShop() {
      return $utils.data.get('auth', 'is_shop') || false
    },
  },
  created() {
    this.loadHomeData()
    // this.loadtab()
  },
  methods: {
    toUrl(url) {
            return $utils.url.push({name:url})
        },
    loadHomeData() {
      let q = {}
      $utils.api.load('analysisSimpleInfo', q).then((res) => {
        if (res.data) {
          this.simple_info = res.data
        }
      })
    },
    // loadHomeData() {
    //   let q = {}
    //   $utils.api.load('statisticsstats', q).then((res) => {
    //     if (res.data) {
    //       this.simple_infos = res.data
    //     }
    //   })
    // },
  },
}
</script>
